import { rem } from 'polished';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  gap: ${rem('13px')};
  align-items: center;

  dt:nth-child(2) {
    color: ${({ theme }) => theme.colors.tenant.main};
    cursor: pointer;
    font-size: ${rem('14px')};
    font-weight: 400;
  }
`;
